import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { RAIL_ITEMS, canOpen } from "@/components/shell/navConfig";

export const railItemsFor = (user, apps) => RAIL_ITEMS.filter((i) => i.always || canOpen(user, apps, i.to));

export const isRailActive = (pathname, to) => (to === "/dashboard" ? pathname === "/dashboard" : pathname === to || pathname.startsWith(`${to}/`));

export const LeftRail = () => {
  const { user, apps } = useAuth();
  const { pathname } = useLocation();
  const nav = useNavigate();
  return (
    <aside className="hidden md:flex fixed left-0 top-28 bottom-0 z-30 w-20 flex-col items-stretch gap-1 bg-white border-r border-border py-3 px-2" data-testid="left-rail">
      {railItemsFor(user, apps).map((i) => {
        const active = isRailActive(pathname, i.to);
        return (
          <button key={i.key} onClick={() => nav(i.to)} data-testid={`rail-${i.key}`} aria-current={active ? "page" : undefined}
            className={`flex flex-col items-center gap-1 rounded-lg py-2.5 transition-colors ${active ? "bg-navy text-white" : "text-slate-600 hover:bg-sage hover:text-navy"}`}>
            <i.icon className="h-5 w-5" />
            <span className="text-[10px] leading-tight text-center font-medium">{i.label}</span>
          </button>
        );
      })}
    </aside>
  );
};
